import classNames from "classnames";
import * as React from "react";
import { Input, Label } from "uxp/components";
import { hasValue, parseValue } from "../../../../util";
import { IBaseFieldProperty, IBaseInputFieldProperty, IPropertyEditorProps, IUIFieldProps, registerUIField } from "../../common";
import { FieldProperty, FieldTitle, IFieldTitleProps } from "../../components/FieldTitle";
import { CustomColorPicker, escapeUnit, Property, PropertyContainer, PropertyGroup, PropertyGroupTitle, PropertyTitle, TextAlignEditor } from "../../ui-props/common";
import './Ratings.scss';
interface IRatingFieldProperty extends IBaseInputFieldProperty {
    maxValue: string;
    fieldLabel: IFieldTitleProps;
    fontSize:string;
    fontColor:string;
}

export const Field: React.FunctionComponent<IUIFieldProps<IRatingFieldProperty>> = (props) => {

	let {  onChange, value,maxValue,fontSize,fontColor } = props.fieldProps || {}
	let [error, setError] = React.useState(null);

	let styles: React.CSSProperties = { }

	if (hasValue(fontSize)) styles.fontSize = fontSize;


	let v= Number(value) || 0;
    let mv = Number(maxValue) || 5;
    let stars:React.ReactElement[] = [];

    for(let i=0;i<mv;i++) {
        stars.push(<div
        title={'Rating ' + value}
            onClick={()=>onChange(i+1)}
            style={Object.assign({},styles,{color:parseValue(fontColor, props.contextData)})} className={classNames('star',{selected:v>i})}></div>);
    }
	return (
		<div className={classNames('ui-field-rating ui-field', props.mode)} >
			<FieldTitle {...props?.fieldProps?.fieldLabel || {}} />
			<div className='ui-field-rating-items'>
                {stars}
            </div>
		</div >
	)
}


export const PropertyEditor: React.FunctionComponent<IPropertyEditorProps<IRatingFieldProperty>> = (props) => {
	const { uiProps } = props

	return <PropertyContainer>
		<PropertyGroup>
			<PropertyGroupTitle>Rating Field</PropertyGroupTitle>

            <FieldProperty uiProps={props.uiProps} onChange={props.onChange} />
			<Property>
				<PropertyTitle>Max Value</PropertyTitle>
				<Input
                type='number'
					value={props.uiProps.maxValue || ''}
					onChange={s => props.onChange(Object.assign({}, props.uiProps, { maxValue: s }))}
				/>
			</Property>
            <Property>
				<PropertyTitle>Font Size (px) </PropertyTitle>
				<Input
					type='number'
					value={escapeUnit(`${uiProps.fontSize || '20'}`, 'px')}
					onChange={s => {
						let num = Number(s) || 0
						if (num < 8) s = '8'
						else if (num > 200) s = '200'

						props.onChange(Object.assign({}, uiProps, { fontSize: s + 'px' }))
					}}
					inputAttr={{
						max: '200',
						min: '8'
					}}
					className="widget-designer-input"
				/>
			</Property>
            <Property>
				<PropertyTitle>Color</PropertyTitle>
				<CustomColorPicker contextData={props.contextData}
					color={uiProps.fontColor}
					onChange={s => props.onChange(Object.assign({}, uiProps, { fontColor: s }))}
				/>
			</Property>



		</PropertyGroup>

	</PropertyContainer>;
}
registerUIField({
	id: 'rating',
	description: 'Rating ',
	field: Field,
	isInputField: true,
	propertyEditor: PropertyEditor,
	defaultProps: {
		value: 0,
        maxValue:'5',
        fontSize:'20',
        fontColor:'blue',
		fieldLabel: {
			label: 'Rating',
		},
	},
	type:'position'

});


